import { Control, Controller } from 'react-hook-form';
import { Text, View } from 'react-native';
import { Switch } from '@/components/ui/switch';
import { ThemedText } from '../themed-text';

type Props = {
  control: Control<any>;
  name: string;
  label: string;
  /** Texto de apoio abaixo do rótulo, em linguagem simples */
  helperText?: string;
  disabled?: boolean;
  labelReverse?: boolean;
  /** Mantém switch e label adjacentes (ex.: login). Padrão: label e switch nas extremidades. */
  inline?: boolean;
  colorText?: string;
  /** testID repassado ao Switch */
  testID?: string;
};

const ERROR_COLOR = '#EF4444';

/**
 * Linha rótulo + Switch (design system) — leitura de "liga/desliga" mais clara
 * que checkbox para perguntas do tipo "É recorrente?".
 */
export function ControlledCheckbox({
  control,
  name,
  label,
  helperText,
  disabled = false,
  labelReverse = false,
  inline = false,
  colorText,
  testID,
}: Props) {
  const rowDirectionClass = labelReverse ? 'flex-row-reverse' : 'flex-row';
  const rowLayoutClass = inline
    ? `${rowDirectionClass} items-center gap-3 self-start`
    : `${rowDirectionClass} w-full items-center justify-between gap-3`;

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <View className={inline ? undefined : 'w-full py-1'}>
          <View className={rowLayoutClass}>
            <View className={inline ? undefined : 'flex-1 gap-0.5'}>
              <ThemedText className={colorText ?? 'text-neutral-800'} type="labelInput">
                {label}
              </ThemedText>
              {helperText ? (
                <ThemedText className="text-xs leading-4 text-neutral-500">{helperText}</ThemedText>
              ) : null}
            </View>

            <Switch
              checked={!!value}
              onCheckedChange={onChange}
              disabled={disabled}
              testID={testID}
            />
          </View>

          {error && (
            <Text className="mt-1 text-xs" style={{ color: ERROR_COLOR }}>
              {error.message}
            </Text>
          )}
        </View>
      )}
    />
  );
}
